<template>
  <div class="app-main-content">
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%" @tab-click="handleTabClick">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BusinessStatusManagement')" name="businessStatusManagement">
          <tenant-business-status-management ref="businessStatusManagement" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TriggerTypeManagement')" name="triggerTypeManagement">
          <trigger-type-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OperationInstructionsManagement')" name="operationInstructionsManagement">
          <div v-if="isPlatform">
            <platform-instruction />
          </div>
          <div v-else>
            <tenant-instruction-wrap ref="tenantInstructionWrap" />
          </div>
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.ServiceScenarioApplication')" name="specificBusinessRule">
          <specific-business-rule />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_WarnRuleConfiguration')" name="warnRuleConfiguration">
          <warn-rule-configuration />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TenantBusinessStatusManagement from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/index'
import TriggerTypeManagement from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/triggerTypeManagement'
import PlatformInstruction from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/platformInstruction'
import TenantInstructionWrap from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionWrap'
import SpecificBusinessRule from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/specificBusinessRule'
import WarnRuleConfiguration from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration'
import {
  ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT, ACTIVE_TAB_NAME_OPERATION_INSTRUCTIONS_MANAGEMENT
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'SopConfig',
  components: {
    TenantBusinessStatusManagement, TriggerTypeManagement, PlatformInstruction, TenantInstructionWrap,
    SpecificBusinessRule, WarnRuleConfiguration
  },
  data() {
    return {
      loading: true,
      activeTabName: ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT.code
    }
  },
  computed: {
    isPlatform() {
      return this.$store.getters.tenantId === 1
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  async created() {
  },
  methods: {
    handleTabClick() {
      this.$nextTick(() => {
        if (this.activeTabName === ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT.code) {
          this.$refs.businessStatusManagement.initTenantInstructionAndRule()
        } else if (this.activeTabName === ACTIVE_TAB_NAME_OPERATION_INSTRUCTIONS_MANAGEMENT.code) {
          if (this.$refs.tenantInstructionWrap) {
            this.$refs.tenantInstructionWrap.initPlatformInstructionAndMailTemplate()
          }
        }
      })
    }
  }
}
</script>
